import Head from 'next/head';
import { useIntl } from 'react-intl';

type SeriesHeadProps = {
  description?: string;
  title: string;
};

const SeriesHead = ({ title, description }: SeriesHeadProps) => {
  const intl = useIntl();

  return (
    <Head>
      <title>{`${title} | ${intl.formatMessage({ defaultMessage: 'TED Series' })}`}</title>
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta name="description" content={description} />
    </Head>
  );
};

export default SeriesHead;
